import { PrimaryActionCard } from "../../components/common/PrimaryActionCard";
import { KioskLayout } from "../../components/kiosk/KioskLayout";

export function KioskHomePage() {
  return (
    <KioskLayout
      title="Benvenuto"
      subtitle="Scegli l'operazione da eseguire."
      showBack={false}
    >
      <section className="hero-grid">
        <PrimaryActionCard
          to="/checkin"
          title="Ingresso"
          description="Registra un nuovo visitatore con firma obbligatoria."
        >
          Accesso
        </PrimaryActionCard>
        <PrimaryActionCard
          to="/checkout"
          title="Uscita"
          description="Chiudi una visita aperta e acquisisci la firma finale."
        >
          Chiusura visita
        </PrimaryActionCard>
      </section>
    </KioskLayout>
  );
}
